<template>
  <el-dialog
      v-model="dialogVisible"
      :title="formData.ID?'编辑学校':'新增学校'"
      height="400px"
      width="750px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="handleClose">
    <div class="dialog-item1">
      <el-form :rules="rules" :model="formData" label-width="auto"  class="el-form-box" ref="ruleFormRef">
        <el-row :gutter="10">
          <el-col :span="12" >
            <el-form-item label="学校名称：" prop="Name"  >
              <el-input v-model="formData.Name" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="办学层次：" prop="Level" >
              <el-select v-model="formData.Level" placeholder="请选择">
                <el-option v-for="item of SCHOOLLEVELS" :key="item.ID" :value="item.ID" :label="item.Name"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在国家：" prop="Country" >
              <el-input type="text" v-model="formData.Country" >
                <template #prepend>
                  <el-select v-model="formData.isChina" @change="isChinaChoise" placeholder="请选择" style="width: 90px">
                    <el-option :value="true" label="中国"/>
                    <el-option :value="false" label="其他"/>
                  </el-select>
                </template>
              </el-input>
<!--              <el-input v-model="formData.Country" placeholder="请输入"/>-->
<!--              <el-select v-model="formData.Country" placeholder="请选择">-->
<!--                <el-option value="中国" label="中国"/>-->
<!--                <el-option value="其他" label="其他"/>-->
<!--              </el-select>-->
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.isChina">
            <el-form-item
                label="所在省份："
                prop="Province"
                :rules="{required:formData.isChina,message: '请输入所在省份', trigger: ['change', 'blur']}" >
<!--              <el-input v-model="formData.Province" placeholder="请输入"/>-->
              <el-select v-model="formData.Province"  clearable filterable>
                <el-option v-for="i of provinces" :key="i" :value="i" :label="i.Name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在地：" prop="City"  >
              <el-input v-model="formData.City" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="主管部门：" prop="Department"  >
              <el-input v-model="formData.Department" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学校标签：" prop="Tags"  >
<!--              <el-input v-model="formData.Tags" placeholder="请输入"/>-->
              <el-input-tag
                  :trigger="'Space'"
                  :max="5"
                  v-model="formData.Tags"
                  placeholder="请输入关键字(985,211,双一流)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学校代码：" prop="Code"  >
              <el-input v-model="formData.Code" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.isChina">
            <el-form-item label="省份代码：" prop="ProvinceCode"  >
              <el-input v-model="formData.ProvinceCode" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="save(ruleFormRef)"
                   :loading = "loading">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, reactive,onMounted} from 'vue';
import {ElMessage} from "element-plus";
import {validateForm} from "@/utils/formValidate";
import {SCHOOLLEVELS} from "@/utils/commonSetting"
import {addUniversity, updateUniversity} from "@/api/schoolAdmin";
import {getProvinces} from "@/api/school";
const emits = defineEmits(['close', 'success'])
const dialogVisible = ref(true)
const ruleFormRef = ref()
const provinces = ref([]) // 省份列表
var formData = reactive({
  ID:null,
  Name: null, //string // 学校名称
  City: null, //"string",//所在地
  Code: null, //学校标识
  Department:null, // "string",主管部门
  Level:null, // "string",办学层次
  Notes: null, //"string",备注
  Province: null, //"string",所在省份
  ProvinceCode: null, //"string",省份代码
  Country:"中国", // 所在国家
  isChina:true,
  Tags:"", // 学校标签
})
const rules = ({
  Name: [{required: true, message: '请输入学校名称', trigger: ['change', 'blur']}],
  City: [{required: true, message: '请输入学校所在地', trigger: ['change', 'blur']}],
  Country: [{required: true, message: '请输入所在国家', trigger: ['change', 'blur']}],
  // Code: [{required: true, message: '请输入学校代码', trigger: ['change', 'blur']}],
  Department: [{required: true, message: '请输入主管部门', trigger: ['change', 'blur']}],
  Level: [{required: true, message: '请选择办学层次', trigger: ['change', 'blur']}],
  // Province: [{required: true, message: '请输入所在省份', trigger: ['change', 'blur']}],
  // ProvinceCode: [{required: true, message: '请输入省份代码', trigger: ['change', 'blur']}],
})
const loading = ref(false)


const props = defineProps({
  item: {
    default: {},
  }
})
// 开始
onMounted(()=>{
  getProvincesAll() // 获取所有的省份列表
  if(props.item && props.item.ID){
    formData.Name = props.item.Name
    formData.City = props.item.City
    formData.Code = props.item.Code
    formData.Department = props.item.Department
    formData.Level = props.item.Level
    formData.Notes = props.item.Notes
    formData.Province = props.item.Province
    formData.ProvinceCode = props.item.ProvinceCode
    formData.ID = props.item.ID
    formData.Country = props.item.Country?props.item.Country:"中国"
    formData.isChina = props.item.Country=='中国'
    formData.Tags = props.item.Tags?props.item.Tags.split(","):null
  }
})
// 获取省份列表
const getProvincesAll = async ()=>{
  const res = await getProvinces()
  if(res.success){
    provinces.value = res.data || []
  }
}
const handleClose = () => {
  dialogVisible.value = false
  emits("close", true)
}
// 保存
const save = async (ruleFormRef) => {
  const isvalidate =await validateForm(ruleFormRef)
  if(!isvalidate){
    return
  }
  loading.value = true
  let res,messPre;
  const params = {
    ...formData,
    Tags:formData.Tags?formData.Tags.join(","):""
  }
  if(!params.isChina){
    params.Province = ""
    params.ProvinceCode = ""
  }
  if( formData.ID){
    res = await updateUniversity(params)
    messPre = '修改'
  }else{
    res = await addUniversity(params)
    messPre = '创建'
  }
  loading.value = false
  if(res.success){
    ElMessage.success(messPre + "成功")
    emits("success", true)
  }else{
    ElMessage.warning(res.err_msg || messPre + "失败")
  }

}
const isChinaChoise = ()=>{
  if(formData.isChina){
    formData.Country = "中国"
  }else{
    formData.Country = ""
  }
}
</script>

<style scoped>
.dialog-item1 {
  width: 100%;
  height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
